import {DifferentBackgroundSectionV2, SameBackgroundSectionV2} from "@commons/uinew/section/DifferentBackgroundSection";

export let SectionWrapper = ({children, differentColor}) => {
    let Component = differentColor ? DifferentBackgroundSectionV2 : SameBackgroundSectionV2

    return <Component>
        {children}
    </Component>
}